import DesCreateLibraryFolderViewModel from 'viewmodel/DesCreateLibraryFolderViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCreateLibraryFolder extends DesBaseCatalogAcc {
    constructor() {
        super(DesCreateLibraryFolderViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get parentFolder() {
        return this.getAttribute('parent-folder') || this.getAttribute('parentfolder');
    }

    get collaborationspaceId() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId,
            parentfolder: this.parentFolder,
            collaborationspaceid: this.collaborationspaceId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'library-id', 'libraryid', 'parent-folder', 'parentfolder',
            'collaborationspaceid', 'collaborationspace-id'];
    }
}

if (!window.customElements.get('des-create-library-folder')) {
    window.customElements.define('des-create-library-folder', DesCreateLibraryFolder);
}
